module.exports = __webpack_public_path__ + "static/media/no-pass.f97840ae.svg";